/**
 * FIN-011 — triggers a browser-initiated download for a blob. Used by
 * FilePackageButton + DownloadPackageButton. Extracted so the side-effecty
 * `document.createElement('a')` flow lives in one place and tests can spy
 * on it via the named export.
 */
export function triggerBrowserDownload(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
